import { Address } from "projects/c1-backend/src/app/db/address";

export class ToDo{
    id:Number=0;
    date_from:any;
    date_to:any;
    id_table:Number=0;
    table:Number=0;
    id_address:Number=0;
    addressname:String="";
    description:String="";
    state:Number=1;
    addressItem:any;
    
}